import { lazy } from 'react'

export const ForgotPwPage = /*@__PURE__*/ lazy(
	() =>
		import(
			/* webpackChunkName: 'forgot-pw' */
			/* webpackPrefetch: 10 */
			'./ForgotPwPage'
		),
)

export const LandingPage = /*@__PURE__*/ lazy(() => import('./LandingPage'))

export * from './PairPage/lazy'
export * from './PwResetPage/lazy'
export * from './VerifyEmailPage/lazy'
